import axios from "axios";
const LOCAL_CACHE_PREFIX = 'digital-content-favorites-';

// public functions
// noinspection JSUnusedGlobalSymbols
export function deleteItem(postId, userId, idToken, onSuccess, onError) {
  axios.delete(process.env.SISER_API_ENDPOINT + 'digital-content/user/' + userId + '/favorite/' + postId, {
    headers: {
      'Authorization': 'Bearer ' + idToken
    }
  }).then(() => {
    removeIdFromLocalCache(postId, userId);
    onSuccess();
  }).catch(err => {
    onError(err);
  });
}

// noinspection JSUnusedGlobalSymbols
export function fetchAll(userId, idToken, onSuccess, onError) {
  // try local cache
  let localCacheResults = fetchCachedFavoriteIds(userId);
  if (localCacheResults !== null) {
    onSuccess(localCacheResults);
    return;
  }

  // fetch from the DB
  axios.get(process.env.SISER_API_ENDPOINT + 'digital-content/user/' + userId + '/favorite', {
    headers: {
      'Authorization': 'Bearer ' + idToken,
      'Cache-Control': 'max-age=0'
    }
  }).then(response => {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(LOCAL_CACHE_PREFIX + userId, JSON.stringify(response.data));
    }
    onSuccess(response.data);
  }).catch(err => {
    onError(err);
  });
}

// noinspection JSUnusedGlobalSymbols
export function insertItem(postId, userId, idToken, onSuccess, onError) {
  axios.post(process.env.SISER_API_ENDPOINT + 'digital-content/user/' + userId + '/favorite', {
    post_id: postId
  }, {
    headers: {
      'Authorization': 'Bearer ' + idToken
    }
  }).then(() => {
    addIdToLocalCache(postId, userId);
    onSuccess();
  }).catch(err => {
    onError(err);
  });
}

// noinspection JSUnusedGlobalSymbols
export function flushCachedFavorites(userId) {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(LOCAL_CACHE_PREFIX + userId);
  }
}
// end public functions

// private functions
function addIdToLocalCache(postId, userId) {
  if (typeof window !== 'undefined') {
    let cachedResultRaw = window.sessionStorage.getItem(LOCAL_CACHE_PREFIX + userId);
    let cachedResults = [];
    if (cachedResultRaw !== null) {
      cachedResults = JSON.parse(cachedResultRaw);
    }
    if (!cachedResults.includes(postId)) {
      cachedResults.push(postId);
      window.sessionStorage.setItem(LOCAL_CACHE_PREFIX + userId, JSON.stringify(cachedResults));
    }
  }
}
function fetchCachedFavoriteIds(userId) {
  let cachedFavorites = null;
  if (typeof window !== 'undefined') {
    let cachedFavoritesRaw = window.sessionStorage.getItem(LOCAL_CACHE_PREFIX + userId);
    if (cachedFavoritesRaw !== null) {
      cachedFavorites = JSON.parse(cachedFavoritesRaw);
    }
  }
  return cachedFavorites;
}
function removeIdFromLocalCache(postId, userId) {
  if (typeof window !== 'undefined') {
    let cachedResultRaw = window.sessionStorage.getItem(LOCAL_CACHE_PREFIX + userId);
    let cachedResults = [];
    if (cachedResultRaw !== null) {
      cachedResults = JSON.parse(cachedResultRaw);
    }
    let index = cachedResults.indexOf(postId);
    if (index > -1) {
      cachedResults.splice(index, 1);
      window.sessionStorage.setItem(LOCAL_CACHE_PREFIX + userId, JSON.stringify(cachedResults));
    }
  }
}
// end private functions